import { background000, background050, background100, background600, background700, primary050, primary080, primary100, primary400, primary500, primary600, primary700, text000, text100, text200, text300, text600, yellow050, yellow100, yellow200, green400, green500, blue400, orange400, red400, } from './colorsV3';
const themeV3 = {
    mode: 'light',
    device: 'mobile',
    reducedMotion: false,
    colors: {
        text: primary100,
        background: background100,
        primary: primary100,
        backgrounds: {
            content: {
                background: background000,
                text: [primary100, text100],
                border: primary050,
            },
            contentHighlight: {
                background: background100,
                text: [primary100, text100],
                border: primary700,
            },
            primaryNavigation: {
                background: primary100,
                text: [text000, text300],
                border: primary400,
            },
            secondaryNavigation: {
                background: primary500,
                text: [text000, text300],
                border: primary080,
            },
            lightNavigation: {
                background: background050,
                text: [primary100, text100],
                border: background600,
            },
            heading: {
                background: background100,
                text: [primary100, text100],
                border: background100,
            },
            headingHighlight: {
                background: background600,
                text: [primary100, text100],
                border: primary700,
            },
        },
        interactions: {
            CTA: {
                default: primary100,
                hover: primary500,
                focus: text300,
                active: primary080,
                text: {
                    default: text000,
                    hover: text000,
                    focus: text000,
                    active: text000,
                },
                border: {
                    default: primary100,
                    hover: primary500,
                    focus: text300,
                    active: primary080,
                },
            },
            primaryCTA: {
                default: yellow050,
                hover: yellow200,
                focus: yellow200,
                active: yellow200,
                text: {
                    default: primary100,
                    hover: primary100,
                    focus: primary100,
                    active: primary100,
                },
                border: {
                    default: yellow100,
                    hover: yellow100,
                    focus: yellow100,
                    active: yellow100,
                },
            },
            oddsCTA: {
                default: background600,
                hover: background700,
                focus: background700,
                active: background700,
                text: {
                    default: primary100,
                    hover: primary100,
                    focus: primary100,
                    active: primary100,
                },
                border: {
                    default: background600,
                    hover: background700,
                    focus: background700,
                    active: background700,
                },
            },
            oddsActive: {
                default: primary100,
                hover: primary500,
                focus: primary500,
                active: primary500,
                text: {
                    default: yellow050,
                    hover: yellow050,
                    focus: yellow050,
                    active: yellow050,
                },
                border: {
                    default: primary100,
                    hover: primary500,
                    focus: primary500,
                    active: primary500,
                },
            },
            oddsConcession: {
                default: yellow050,
                hover: yellow200,
                focus: yellow200,
                active: yellow200,
                text: {
                    default: primary100,
                    hover: primary100,
                    focus: primary100,
                    active: primary100,
                },
                border: {
                    default: yellow100,
                    hover: yellow100,
                    focus: yellow100,
                    active: yellow100,
                },
            },
            oddsFlash: {
                default: primary100,
                hover: primary500,
                focus: primary500,
                active: primary500,
                text: {
                    default: text000,
                    hover: text000,
                    focus: text000,
                    active: text000,
                },
                border: {
                    default: primary100,
                    hover: primary500,
                    focus: primary500,
                    active: primary500,
                },
            },
            inPlay: {
                default: yellow050,
                hover: yellow200,
                focus: yellow200,
                active: yellow200,
                text: {
                    default: primary100,
                    hover: primary100,
                    focus: primary100,
                    active: primary100,
                },
                border: {
                    default: yellow100,
                    hover: yellow100,
                    focus: yellow100,
                    active: yellow100,
                },
            },
            concession: {
                default: green400,
                hover: green500,
                focus: green500,
                active: green500,
                text: {
                    default: primary100,
                    hover: primary100,
                    focus: primary100,
                    active: primary100,
                },
                border: {
                    default: green400,
                    hover: green500,
                    focus: green500,
                    active: green500,
                },
            },
            link: {
                default: primary100,
                hover: text200,
                focus: text200,
                active: text200,
            },
        },
        system: {
            info: {
                background: background600,
                highlight: blue400,
                text: text000,
            },
            warning: {
                background: background600,
                highlight: orange400,
                text: text000,
            },
            error: {
                background: background600,
                highlight: red400,
                text: text000,
            },
            success: {
                background: background600,
                highlight: green400,
                text: primary100,
            },
        },
        dividers: {
            standard100: background100,
            standard120: background600,
        },
        overlay: 'rgba(0,0,0,0.3)',
        shadows: {
            '080': '0px 0px 12px rgba(0, 20, 60, 0.16)',
            '100': '0px 0px 12px rgba(0, 20, 60, 0.16)',
            '120': '0px 0px 12px rgba(0, 20, 60, 0.16)',
            '200': '0 3px 6px 0 rgba(0, 20, 60, 0.16), 0 3px 6px 0 rgba(0, 20, 60, 0.23)',
            '400': '0 14px 28px 0 rgba(0, 20, 60, 0.16), 0 10px 10px 0 rgba(0, 20, 60, 0.16)',
        },
        modes: {
            dark: {
                text: text000,
                background: primary600,
                backgrounds: {
                    content: {
                        background: primary500,
                        text: [text000, background100],
                        border: primary080,
                    },
                    contentHighlight: {
                        background: primary080,
                        text: [text000, background100],
                        border: primary100,
                    },
                    lightNavigation: {
                        background: primary600,
                        text: [text000, text300],
                        border: primary600,
                    },
                },
                interactions: {
                    link: {
                        default: primary050,
                        hover: primary100,
                        focus: primary100,
                        active: primary100,
                    },
                },
                shadows: {
                    '080': '0px 0px 12px rgba(0, 20, 60, 0.16)',
                    '100': '0px 0px 12px rgba(0, 20, 60, 0.16)',
                    '120': '0px 0px 12px rgba(0, 20, 60, 0.16)',
                    '200': '0 3px 6px 0 rgba(0, 20, 60, 0.16), 0 3px 6px 0 rgba(0, 20, 60, 0.23)',
                    '400': '0 14px 28px 0 rgba(0, 20, 60, 0.16), 0 10px 10px 0 rgba(0, 20, 60, 0.16)',
                },
            },
            highContrast: {
                text: text600,
                background: background100,
                shadows: {
                    '080': '0px 0px 12px rgba(0, 20, 60, 0.16)',
                    '100': '0px 0px 12px rgba(0, 20, 60, 0.16)',
                    '120': '0px 0px 12px rgba(0, 20, 60, 0.16)',
                    '200': '0 3px 6px 0 rgba(0, 20, 60, 0.16), 0 3px 6px 0 rgba(0, 20, 60, 0.23)',
                    '400': '0 14px 28px 0 rgba(0, 20, 60, 0.16), 0 10px 10px 0 rgba(0, 20, 60, 0.16)',
                },
            },
        },
    },
    space: [
        '0px',
        '2px',
        '4px',
        '8px',
        '12px',
        '16px',
        '20px',
        '24px',
        '28px',
        '32px',
        '36px',
    ],
    radii: ['0px', '2px', '5px', '10px', '20px', '9999px'],
    zIndex: {
        header: 96,
        toolbar: 98,
        sidenav: 99,
        modal: 100,
        tooltip: 10,
    },
    fonts: {
        body: 'Verdana, sans-serif',
        heading: 'inherit',
        monospace: 'Menlo, monospace',
    },
    fontSizes: ['11px', '12px', '13px', '16px', '18px', '20px'],
    lineHeights: ['12px', '16px', '16px', '20px', '22px', '24px'],
    fontWeights: {
        body: 400,
        heading: 400,
        bold: 700,
    },
    letterSpacings: {
        body: 'normal',
        heading: 'normal',
    },
    animations: {
        in: 'ease-in',
        out: 'ease-in',
        timeDefault: '.3s',
        spring: {
            mass: 1,
            tension: 170,
            friction: 25,
            velocity: 0,
            precision: 0.01,
            delay: 0,
        },
    },
    styles: {
        html: {
            boxSizing: 'border-box',
            lineHeight: '1.15',
            fontFamily: 'Verdana, sans-serif',
        },
        'body, html': {
            margin: 0,
            padding: 0,
            minHeight: '100%',
            width: '100%',
            fontSize: '100%',
        },
        '*, *::before, *::after': {
            boxSizing: 'inherit',
        },
    },
};
export default themeV3;
